import React, { FC } from 'react';
import ListMeRepositories from '../../components/core/ListMeRepositories/ListMeRepositories';
import ListRepositories from '../../components/core/ListRepositories/ListRepositories';
import ModalAccess from '../../components/core/Modal-Access/Modal-Access';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';
import '../../pages/PortalDocuments/PortalDocuments.css'

interface PortalDocumentsProps {}

const PortalDocuments: FC<PortalDocumentsProps> = () => (
  <div>
  <PrimaryNavigation />
  <div className="PortalDocumentsRepositories">
  <div className="table-container">
 <ListRepositories></ListRepositories>
  </div>
</div>
</div>
);

export default PortalDocuments;
